// init locales before component imports
import './init-locales';

import { createRoot } from 'react-dom/client';

import { initializeErrorTracking } from '@portal/common/services/error-tracking';
import { GoogleAnalyticsProvider } from '@portal/common/services/google-analytics';
import { StorageProvider, localStorageAdapter } from '@portal/common/services/local-storage';
import { withProfiler } from '@portal/common/services/sentry';
import { MediaProvider, ThemeProvider } from '@portal/common/theme';
import { initializeFonts } from '@portal/common/theme/fonts';

import Root from './components/Root';
import config from './config';
import defaultTheme from './theme/theme-config';

initializeErrorTracking(config.sentryDsn, config.logRocketDsn);
initializeFonts();

const App = withProfiler(() => (
    <ThemeProvider theme={defaultTheme}>
        <MediaProvider>
            <StorageProvider
                version={config.storageCacheVersion}
                storageAdapter={localStorageAdapter}
            >
                <GoogleAnalyticsProvider
                    googleAnalyticsId={config.googleAnalyticsId}
                    debug={config.googleAnalyticsDebug}
                >
                    <Root />
                </GoogleAnalyticsProvider>
            </StorageProvider>
        </MediaProvider>
    </ThemeProvider>
));

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(<App />);
}
